import { render, staticRenderFns } from "./VideoFullScreen.vue?vue&type=template&id=501df004"
import script from "./VideoFullScreen.vue?vue&type=script&lang=js"
export * from "./VideoFullScreen.vue?vue&type=script&lang=js"
import style0 from "./VideoFullScreen.vue?vue&type=style&index=0&id=501df004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports